import { Component, OnInit, ViewChild } from '@angular/core';
// tslint:disable-next-line:max-line-length
import { TripsArry, MethodOfPayment, Account, Vehicle, TripExpenses, Drivers, TripDrivers, TripDriversPostback, CustomerRow } from '../trips-main/trips';
import { SharedService } from '../../../../shared/shared.service';
import { HttpClient } from '@angular/common/http';
import { DataSource } from '@angular/cdk/table';
import { TripService } from '../trips-main/trip.services';
import { Location } from '@angular/common';
import * as moment from 'moment';
import { UsefulToolsService } from '../../../../shared/other/usefultools.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { TripEditService } from './trips-edit.services';

@Component({
  selector: 'app-trips-edit',
  templateUrl: './trips-edit.component.html',
  styleUrls: ['./trips-edit.component.css']
})
export class TripsEditComponent implements OnInit {

  customerRow: CustomerRow;
  newCustomer = [];
  minDate: Date;
  maxDate: Date;
  currentDate: Date;
  sessionId = sessionStorage.getItem('com-session-id');
  ID = sessionStorage.getItem('trips-id');
  MOP: any;
  ACC: any;
  VEH: any;
  DRV: any;
  GDRV: any;
  TXP: any;
  TRIP: any;
  tempValue: number;
  accountValue: number;
  driverPostB: TripDriversPostback[];
  driver_ID: number;
  payment: any;
  paymentID: number;
  acc: any;
  accountID: number;
  vehcle: any;
  vehicleID: number;
  temp: number;
  allDayFlag: boolean;
  takeTrailor: boolean;
  paid: boolean;
  cancelled: boolean;
  pickupDateTime: string;
  dropOffDateTime: string;
  driverRead: string;
  driverConfirmed: string;
  tripDrivers: TripDrivers[];
  popupVisible = false;
  popupVisibleDelete = false;
  copyTripFrom: any;
  copyTripTo: any;
  mon = false; tue = false; wed = false; thu = false; fri = false; sat = false; sun = false;
  dateArray = [];
  @ViewChild('passengersGrid') passengersGrid: DxDataGridComponent
  @ViewChild('expensesGrid') expensesGrid: DxDataGridComponent
  @ViewChild('driversGrid') driversGrid: DxDataGridComponent

  //for lookups
    searchModeOption: string = "contains";
    searchExprOption: any = "NAME";
    searchExprOptionVeh: any = "FULLNAME";
    searchTimeoutOption: number = 200;
    minSearchLengthOption: number = 0;

  constructor(
    private httpclient: HttpClient,
    public sharedservice: SharedService,
    public trip: TripService,
    private location: Location,
    private usefultoolsservice: UsefulToolsService,
    public tripEditService: TripEditService
  ) { }

  formatDateString = this.sharedservice.dateFormatString;
  formatDateStringNoTime = this.sharedservice.dateFormatStringNoTime;

  async ngOnInit() {
    this.sharedservice.loadingActive = true;

    if (this.trip.trip === undefined) {
      this.location.back();
    } else {

      this.MOP = await this.tripEditService.methodOfPayments(this.ID);
      this.ACC = await this.tripEditService.account();
      this.VEH = await this.tripEditService.vehicle();

      //sort alphabetically
      this.ACC.sort(function(a, b){
        var nameA=a.NAME.toLowerCase(), nameB=b.NAME.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1 
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
      });
      this.MOP.sort(function(a, b){
        var nameA=a.NAME, nameB=b.NAME
        if (nameA < nameB) //sort string ascending
            return -1 
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
      });

      // 0 => new trip; 1 => edit trip
      if (this.trip.trip === 0) {
        this.TRIP = {
          ID: '',
          CUSTOMER: '',
          ALLDAYFLAG: null,
          CANCELLED: null,
          DROPOFFADDRESS: '',
          DROPOFFDATE: null,
          DROPOFFINSTRUCTIONS: '',
          EMAILADDRESS: null,
          EMAILSENT: null,
          INVOICED: null,
          METHODOFPAYMENT_ID: 0,
          NOTESTOCLIENT: '',
          NUMBEROFPEOPLE: null,
          PAID: null,
          PICKUPADDRESS: '',
          PICKUPDATE: null,
          PICKUPINSTRUCTIONS: '',
          SMSSENT: null,
          STOPSADDRESS: '',
          TABACCOUNT_ID: 100,
          TAKETRAILOR: null,
          VEHICLE_ID: 1000,
          CONFIRMEDBYCUSTOMERDATE: null,
          CONFIRMEDBYCUSTOMERTIME: null,
          CONFIRMEDBYDRIVERDATE: null,
          CONFIRMEDBYDRIVERTIME: null,
          DriverReadDate: '',
          FirstDriver: '',
          MethodOfPaymentName: '',
          TabAccName: '',
          Vehicle: ''
        };

        this.paymentID = this.MOP.length - 1;
        this.vehicleID = this.VEH.length - 1;
        this.accountID = this.ACC.length - 1;
        this.TXP = [];
        this.DRV = [];

        this.GDRV = await this.tripEditService.getDrivers();
        this.sortDriver()
        this.sharedservice.loadingActive = false;
      } else {

        this.GDRV = await this.tripEditService.getDrivers();
        this.sortDriver();
        this.DRV = await this.tripEditService.driver(this.ID);
        this.TRIP = await this.tripEditService.trip(this.ID);
        this.TXP = await this.tripEditService.tripExspenses(this.ID);
        console.log(this.TRIP);

        this.transform();

        this.sharedservice.loadingActive = false;
      }
      this.sharedservice.loadingActive = false;
    }
    this.sharedservice.loadingActive = false;
  }

  sortDriver() {
    this.GDRV.sort(function (a, b) {
      if (a.Fullname < b.Fullname) { return -1; }
      if (a.Fullname > b.Fullname) { return 1; }
      return 0;
    })
  }

  transform() {

    if (this.DRV === null) { this.DRV = []; }
    this.newCustomer = [];
    const Customer = this.TRIP.CUSTOMER;
    const Rows = Customer.split('\n');
    for (let RowNo = 0; RowNo < Rows.length; RowNo++) {
      this.customerRow = new CustomerRow();
      if (Rows[RowNo] === '') { continue; }
      if (Rows[RowNo].indexOf(',', 0) !== -1) {
        this.customerRow.name = Rows[RowNo].substring(0, Rows[RowNo].indexOf(',', 0));
        this.customerRow.cell = Rows[RowNo].substring(Rows[RowNo].indexOf(',', 0) + 1, Rows[RowNo].length);
      } else {
        this.customerRow.name = Rows[RowNo];
        this.customerRow.cell = '';
      }
      this.newCustomer.push(this.customerRow);
    }

    // if (this.TRIP.confirmedByDriver != null) {
    //   this.driverRead = this.TRIP.confirmedByDriver;
    // } else {
    //   this.driverRead = null;
    // }

    // if (this.TRIP.confirmedByCustomer != null) {
    //   this.driverConfirmed = this.TRIP.confirmedByCustomer;
    // } else {
    //   this.driverConfirmed = null;
    // }

    if (this.TRIP.ALLDAYFLAG === null) {this.TRIP.ALLDAYFLAG = false}
    if (this.TRIP.CANCELLED === null) {this.TRIP.CANCELLED = false}
    if (this.TRIP.PAID === null) {this.TRIP.PAID = false}
    if (this.TRIP.TAKETRAILOR === null) {this.TRIP.TAKETRAILOR = false}

    if (this.TRIP.METHODOFPAYMENT_ID === null) { this.TRIP.METHODOFPAYMENT_ID = 0; }
    if (this.TRIP.TABACCOUNT_ID === null) { this.TRIP.TABACCOUNT_ID = 100; }
    if (this.TRIP.VEHICLE_ID === null) { this.TRIP.VEHICLE_ID = 1000; }

    if (this.TRIP.pickUpDate != null) {
      const date = new Date(this.TRIP.pickUpDate);
      const formatted = moment(date).format('YYYY-MM-DD HH:mm');
      this.TRIP.pickUpDate = formatted;
    }

    if (this.TRIP.dropOffDate != null) {
      const date = new Date(this.TRIP.dropOffDate);
      const formatted = moment(date).format('YYYY-MM-DD HH:mm');
      this.TRIP.dropOffDate = formatted;
    }
  }

  updateRow() {
    const ids = [];
    this.DRV.forEach(element => {
      ids.push(element.DRIVER_ID);
    });
    if (this.function(ids) === true) {
      this.usefultoolsservice.notify('error', 'You have selected a duplicate driver for this trip, please correct.');
    }
  }

  function(a) {
    const counts = [];
    for (let i = 0; i <= a.length; i++) {
      if (counts[a[i]] === undefined) {
        counts[a[i]] = 1;
      } else {
        return true;
      }
    }
    return false;
  }

  validateEmail(email) {
    const re = /[a-z0-9!#$%&'*+/=?^_\`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_\`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
    return re.test(email);
  }

  validchars(str) {
    const re = /^[a-zA-Z0-9!@#.$%&*_();\-\+=:\'\n\s\r,\"]*$/;
    console.log(re.test(str).toString());
    return re.test(str);
  }
  validateName(str) {
    const re = /^[\040-\176]*$/;
    console.log(re.test(str).toString());
    return re.test(str);

  }

  onFormSubmit() {
    // Save any unsaved data in the grids
    this.driversGrid.instance.saveEditData();
    this.expensesGrid.instance.saveEditData();
    this.passengersGrid.instance.saveEditData();

   

    // validation

  let str = this.TRIP.PICKUPADDRESS + this.TRIP.DROPOFFADDRESS + this.TRIP.STOPSADDRESS + this.TRIP.PICKUPINSTRUCTIONS + this.TRIP.DROPOFFINSTRUCTIONS;
  if (this.validchars(str) != true) {
    this.usefultoolsservice.notify('error', `Invalid character in one of the Address fields, check for special characters e.g "\\ / | ┼ å"`);
    return;
  }
  for (let RowNo = 0; RowNo < this.newCustomer.length; RowNo++) {
    let strName = this.newCustomer[RowNo].name;
    if (this.validateName(strName) != true) {
      this.usefultoolsservice.notify('error', `Invalid character in row: ${RowNo+1} of the Passenger field, check for special characters e.g "\\ / | ┼ å"`);
      return;
    }
    let strCell = this.newCustomer[RowNo].cell;
    if (this.validateName(strCell) != true) {
      this.usefultoolsservice.notify('error', `Invalid character in row: ${RowNo+1} of the Passenger field, check for special characters e.g "\\ / | ┼ å"`);
      return;
    }
    if(strName.indexOf(',') >= 0 && strCell.indexOf(',') >= 0){
      this.usefultoolsservice.notify('error', `No ',' (comma) allowed in the Passenger field`);
      return;
    }
  }


    // no pick up or dropoff date
    if ( this.TRIP.PICKUPDATE === null) {
      this.usefultoolsservice.notify('error', `Required Pick up date`);
      return;
    }
    if ( this.TRIP.DROPOFFDATE === null) {
      this.usefultoolsservice.notify('error', `Required Drop off date`);
      return;
    }
    // date pickup not leter than dropoff
    if (new Date(this.TRIP.PICKUPDATE) > new Date(this.TRIP.DROPOFFDATE)) {
      this.usefultoolsservice.notify('error', `Pick up date cannot be later than drop off date`);
      return;
    }

    // pickup address and dropoff address
    if (this.TRIP.PICKUPADDRESS === '') {
      this.usefultoolsservice.notify('error', `Required: Pick up address`);
      return;
    }
    if (this.TRIP.DROPOFFADDRESS === '') {
      this.usefultoolsservice.notify('error', `Required: Drop off address`);
      return;
    }
    if (this.TRIP.EMAILADDRESS === null) { this.TRIP.EMAILADDRESS = ''}
    // email correct format
    if (this.TRIP.EMAILADDRESS !== '') {
      if (this.validateEmail(this.TRIP.EMAILADDRESS) != true) {
        this.usefultoolsservice.notify('error', `Email not valid`);
        return;
      }
    }

    // number of people
    if (this.TRIP.NUMBEROFPEOPLE === 0 || this.TRIP.NUMBEROFPEOPLE === '') {
      this.usefultoolsservice.notify('error', `Number of People must be greater than 0`);
      return;
    }

    let CustomerString = '';
    for (let RowNo = 0; RowNo < this.newCustomer.length; RowNo++) {
      // tslint:disable-next-line:max-line-length
      CustomerString += (this.newCustomer[RowNo].name === undefined ? '' : this.newCustomer[RowNo].name) + (this.newCustomer[RowNo].cell === undefined ? '' : ',' + this.newCustomer[RowNo].cell) + '\n';
    }

    if (CustomerString === '' || CustomerString.startsWith(',') === true) {
      this.usefultoolsservice.notify('error', `Passenger can't be blank`);
      return;
    }
    // so Dropdown ID dont save to DB, set them 0 'null'
    if (this.TRIP.METHODOFPAYMENT_ID === 0) { this.TRIP.METHODOFPAYMENT_ID = 0; }
    if (this.TRIP.TABACCOUNT_ID === 100) { this.TRIP.TABACCOUNT_ID = 0; }
    if (this.TRIP.VEHICLE_ID === 1000) { this.TRIP.VEHICLE_ID = 0; }

    if (this.TRIP.PAID === null) { this.TRIP.PAID = 0; }
    if (this.TRIP.PAID === -1) { this.TRIP.PAID = 1; }
    if (this.TRIP.EMAILSENT === null) { this.TRIP.EMAILSENT = 1; }
    if (this.TRIP.EMAILSENT === -1) { this.TRIP.EMAILSENT = 1; }
    if (this.TRIP.TAKETRAILOR === null) { this.TRIP.TAKETRAILOR = 0; }
    if (this.TRIP.TAKETRAILOR === -1) { this.TRIP.TAKETRAILOR = 1; }
    if (this.TRIP.ALLDAYFLAG === null) { this.TRIP.ALLDAYFLAG = 0; }
    if (this.TRIP.ALLDAYFLAG === -1) { this.TRIP.ALLDAYFLAG = 1; }
    if (this.TRIP.CANCELLED === null) {this.TRIP.CANCELLED = 0}
    if (this.TRIP.CANCELLED === -1) {this.TRIP.CANCELLED = 1}
    if (this.TRIP.INVOICED === null)  {this.TRIP.INVOICED = 0};
    if (this.TRIP.INVOICED === -1)  {this.TRIP.INVOICED = 1};

    // 0 = new, 1 = old
    if (this.trip.trip === 0) {
      const postThis = {
        SessionID: sessionStorage.getItem('com-session-id'),
        Trip: [{
          'customer': CustomerString,
          'allDayFlag': this.TRIP.ALLDAYFLAG,
          'pickUpDate': moment(this.TRIP.PICKUPDATE).format('YYYY-MM-DD HH:mm').substr(0, 10),
          'pickUpTime': moment(this.TRIP.PICKUPDATE).format('YYYY-MM-DD HH:mm').substr(10, 16),
          'dropOffDate': moment(this.TRIP.DROPOFFDATE).format('YYYY-MM-DD HH:mm').substr(0, 10),
          'dropOffTime': moment(this.TRIP.DROPOFFDATE).format('YYYY-MM-DD HH:mm').substr(10, 16),
          'stopsAddress': this.TRIP.STOPSADDRESS,
          'pickUpAddress': this.TRIP.PICKUPADDRESS,
          'pickUpInstructions': this.TRIP.PICKUPINSTRUCTIONS,
          'dropOffAddress': this.TRIP.DROPOFFADDRESS,
          'numberOfPeople': this.TRIP.NUMBEROFPEOPLE,
          'takeTrailor': this.TRIP.TAKETRAILOR,
          'dropOffInstructions': this.TRIP.DROPOFFINSTRUCTIONS,
          'confirmedByCustomerDate': this.TRIP.confirmedByCustomer = null,
          'confirmedByCustomerTime': this.TRIP.confirmedByCustomer = null,
          'confirmedByDriverDate': this.TRIP.confirmedByDriver = null,
          'confirmedByDriverTime': this.TRIP.confirmedByDriver = null,
          'emailSent': 1,
          'cancelled': this.TRIP.CANCELLED,
          'smsSent': this.TRIP.SMSSENT,
          'methodOfPayment_Id': this.TRIP.METHODOFPAYMENT_ID,
          'vehicle_Id': this.TRIP.VEHICLE_ID,
          'emailAddress': this.TRIP.EMAILADDRESS,
          'paid': this.TRIP.PAID,
          'notesToClient': this.TRIP.NOTESTOCLIENT,
          'invoiced': this.TRIP.INVOICED,
          'tabAccount_ID': this.TRIP.TABACCOUNT_ID,
          'DriverReadDate': this.TRIP.CONFIRMEDBYDRIVERDATE
        }]
      };
      this.httpclient.post<any>(`${this.sharedservice.URL}/dbTrip`, postThis).subscribe(Response => {
        // tslint:disable-next-line:max-line-length
        if (Response.dbTrip_response.ServiceResults[0].RESULTACTION === 'insert' && Response.dbTrip_response.ServiceResults[0].RESULTDESCRIPTION === 'success') {
          this.usefultoolsservice.notify('success', this.sharedservice.notificationMessages.successInsert);
          this.ID = Response.dbTrip_response.LastID;
          this.driversPostBack();
          // this.DRVpostback();
        } else {
          this.usefultoolsservice.notify('error', `Error: ${Response.dbTrip_response.ServiceResults[0].ERRORDESCRIPTION}`);
        }
      });
    } else {
      const postThis = {
        SessionID: sessionStorage.getItem('com-session-id'),
        Trip: [{
          'ID': this.TRIP.ID,
          'customer': CustomerString,
          'allDayFlag': this.TRIP.ALLDAYFLAG,
          'pickUpDate': moment(this.TRIP.PICKUPDATE).format('YYYY-MM-DD HH:mm').substr(0, 10),
          'pickUpTime': moment(this.TRIP.PICKUPDATE).format('YYYY-MM-DD HH:mm').substr(10, 16),
          'dropOffDate': moment(this.TRIP.DROPOFFDATE).format('YYYY-MM-DD HH:mm').substr(0, 10),
          'dropOffTime': moment(this.TRIP.DROPOFFDATE).format('YYYY-MM-DD HH:mm').substr(10, 16),
          'stopsAddress': this.TRIP.STOPSADDRESS,
          'pickUpAddress': this.TRIP.PICKUPADDRESS,
          'pickUpInstructions': this.TRIP.PICKUPINSTRUCTIONS,
          'dropOffAddress': this.TRIP.DROPOFFADDRESS,
          'numberOfPeople': this.TRIP.NUMBEROFPEOPLE,
          'takeTrailor': this.TRIP.TAKETRAILOR,
          'dropOffInstructions': this.TRIP.DROPOFFINSTRUCTIONS,
          'confirmedByCustomerDate': this.TRIP.confirmedByCustomer = null,
          'confirmedByCustomerTime': this.TRIP.confirmedByCustomer = null,
          'confirmedByDriverDate': this.TRIP.confirmedByDriver = null,
          'confirmedByDriverTime': this.TRIP.confirmedByDriver = null,
          'emailSent': this.TRIP.EMAILSENT,
          'cancelled': this.TRIP.CANCELLED,
          'smsSent': this.TRIP.SMSSENT,
          'methodOfPayment_Id': this.TRIP.METHODOFPAYMENT_ID,
          'vehicle_Id': this.TRIP.VEHICLE_ID,
          'emailAddress': this.TRIP.EMAILADDRESS,
          'paid': this.TRIP.PAID,
          'notesToClient': this.TRIP.NOTESTOCLIENT,
          'invoiced': this.TRIP.INVOICED,
          'tabAccount_ID': this.TRIP.TABACCOUNT_ID,
          'DriverReadDate': this.TRIP.CONFIRMEDBYDRIVERDATE
        }]
      };
      this.httpclient.put<any>(`${this.sharedservice.URL}/dbTrip`, postThis).subscribe(Response => {
        console.log(Response);
        // tslint:disable-next-line:max-line-length
        if (Response.dbTrip_response.ServiceResults[0].RESULTDESCRIPTION === 'success' && Response.dbTrip_response.ServiceResults[0].RESULTACTION === 'updateinsert') {
          this.usefultoolsservice.notify('success', this.sharedservice.notificationMessages.successUpdate);
          this.driversPostBack();
          // this.DRVpostback();
        } else {
          this.usefultoolsservice.notify('error', `Error: ${Response.dbTrip_response.ServiceResults[0].ERRORDESCRIPTION}`);
        }
      });
    }
  }

  dropoffdateset() {
    const x = new Date(this.TRIP.PICKUPDATE);
    x.setHours(x.getHours() + 1);
    this.TRIP.DROPOFFDATE = x.toString();
  }

  driversPostBack() {

    this.driverPostB = [];
    if (this.DRV.length !== 0 || this.DRV !== undefined) {
      this.DRV.forEach(element1 => {
        if (element1.hasOwnProperty('__KEY__')) { delete element1['__KEY__']; }
        this.driverPostB.push({ TRIP_ID: this.ID, DRIVER_ID: element1.DRIVER_ID.toString() });
      });
      const postThis = {
        SessionID: sessionStorage.getItem('com-session-id'),
        TripDriver: this.driverPostB,
        DeleteForTripID: this.ID
      };
      this.httpclient.post<any>(`${this.sharedservice.URL}/dbTripDriver`, postThis).subscribe(Response => {
        this.expensesPostback();
      });
    } else {
      this.expensesPostback();
    }
  }


  logMe() {

    console.log('trip');
    console.log(this.TRIP);

    console.log('vehicle ID');
    console.log(this.TRIP.vehicle_Id);
    console.log('method of payment');
    console.log(this.TRIP.methodOfPayment_Id);
    console.log('tab account ID');
    console.log(this.TRIP.tabAccount_ID);

    console.log('acc');
    console.log(this.ACC);
    console.log('vehicle');
    console.log(this.VEH);
    console.log('method of payment');
    console.log(this.MOP);

    console.log('trip exspenses');
    console.log(this.TXP);
    console.log('drivers');
    console.log(this.DRV);
    console.log('drivers length');
    console.log(this.DRV.length);
    console.log('get drivers');
    console.log(this.GDRV);
  }

  expensesPostback() {
    this.TXP.forEach(x => {
      x.TRIP_ID = this.ID;

      if (x.hasOwnProperty('__KEY__')) { delete x['__KEY__']; }
    })

    if (this.TXP !== undefined) {
      const postThis = { SessionID: sessionStorage.getItem('com-session-id'), DeleteForTripID: this.ID, TripExpense: this.TXP };
      this.httpclient.post<any>(`${this.sharedservice.URL}/dbTripExpense`, postThis).subscribe(Response => {
        this.location.back();
      });
    }
    this.ID = null;
    this.DRV = [];
    this.TXP = [];
  }

  delete() {
    this.sharedservice.loadingActive = true;
    const blankArray = [];
    const postThis1 = { SessionID: sessionStorage.getItem('com-session-id'), DeleteForTripID: this.ID, TripExpense: blankArray};
    this.httpclient.post<any>(`${this.sharedservice.URL}/dbTripExpense`, postThis1).subscribe(Response => {
    });
    const postThis2 = { SessionID: sessionStorage.getItem('com-session-id'), DeleteForTripID: this.ID, TripDriver: blankArray };
    this.httpclient.post<any>(`${this.sharedservice.URL}/dbTripDriver`, postThis2).subscribe(Response => {
    });
    this.httpclient.delete<any>(`${this.sharedservice.URL}/dbTrip?SessionID=${this.sessionId}&ID=${this.ID}`).subscribe(Response => {
      console.log(Response);
      if (Response.dbTrip_response.ServiceResults[0].RESULTDESCRIPTION === 'success' && Response.dbTrip_response.ServiceResults[0].RESULTACTION === 'Delete') {
        this.usefultoolsservice.notify('success', this.sharedservice.notificationMessages.successDelete);
        this.sharedservice.loadingActive = false;
        this.location.back();
      } else {
        this.usefultoolsservice.notify('error', `Error: ${Response.dbTrip_response.ServiceResults[0].ERRORDESCRIPTION}`);
        this.sharedservice.loadingActive = false;
      }
      this.sharedservice.loadingActive = false;
    });
  }

  srtDriverValue(rowData: any, value: any) {
    rowData.ID = null;
    (<any>this).defaultSetCellValue(rowData, value);
  }

  popup() {
    this.popupVisible = true;
  }

  copyTrip() {
    this.dateArray = [];
    this.mon = this.tue = this.wed = this.thu = this.fri = this.sat = this.sun = false;
    let currentDate = moment(this.copyTripFrom);
    const stopDate2 = moment(this.copyTripTo);

    while (currentDate <= stopDate2) {
      const temp = moment(currentDate);
      const temp2 = moment(temp).format('llll').toString();

      if (temp2.indexOf('Mon') === 0) { this.mon = true; }
      if (temp2.indexOf('Tue') === 0) { this.tue = true; }
      if (temp2.indexOf('Wed') === 0) { this.wed = true; }
      if (temp2.indexOf('Thu') === 0) { this.thu = true; }
      if (temp2.indexOf('Fri') === 0) { this.fri = true; }
      if (temp2.indexOf('Sat') === 0) { this.sat = true; }
      if (temp2.indexOf('Sun') === 0) { this.sun = true; }
      this.pushData(temp);
      currentDate = moment(currentDate).add(1, 'days');
    }
  }

  postTrip() {
    let count = 0;
    let countsuc = 0;
    this.dateArray.forEach(element1 => {
      const element = moment(element1).format('llll').toString();
      if (element.indexOf('Mon') === 0 && this.mon === false) { this.dateArray.splice(count, 1); }
      if (element.indexOf('Tue') === 0 && this.tue === false) { this.dateArray.splice(count, 1); }
      if (element.indexOf('Wed') === 0 && this.wed === false) { this.dateArray.splice(count, 1); }
      if (element.indexOf('Thu') === 0 && this.thu === false) { this.dateArray.splice(count, 1); }
      if (element.indexOf('Fri') === 0 && this.fri === false) { this.dateArray.splice(count, 1); }
      if (element.indexOf('Sat') === 0 && this.sat === false) { this.dateArray.splice(count, 1); }
      if (element.indexOf('Sun') === 0 && this.sun === false) { this.dateArray.splice(count, 1); }
      count++;
    });

    if (this.TRIP.METHODOFPAYMENT_ID === 0) { this.TRIP.METHODOFPAYMENT_ID = 0; }
    if (this.TRIP.TABACCOUNT_ID === 100) { this.TRIP.TABACCOUNT_ID = 0; }
    if (this.TRIP.VEHICLE_ID === 1000) { this.TRIP.VEHICLE_ID = 0; }

    if (this.TRIP.PAID === null) { this.TRIP.PAID = 0; }
    if (this.TRIP.PAID === -1) { this.TRIP.PAID = 1; }
    if (this.TRIP.EMAILSENT === null) { this.TRIP.EMAILSENT = 1; }
    if (this.TRIP.EMAILSENT === -1) { this.TRIP.EMAILSENT = 1; }
    if (this.TRIP.TAKETRAILOR === null) { this.TRIP.TAKETRAILOR = 0; }
    if (this.TRIP.TAKETRAILOR === -1) { this.TRIP.TAKETRAILOR = 1; }
    if (this.TRIP.ALLDAYFLAG === null) { this.TRIP.ALLDAYFLAG = 0; }
    if (this.TRIP.ALLDAYFLAG === -1) { this.TRIP.ALLDAYFLAG = 1; }
    if (this.TRIP.CANCELLED === null) {this.TRIP.CANCELLED = 0}
    if (this.TRIP.CANCELLED === -1) {this.TRIP.CANCELLED = 1}
    if (this.TRIP.INVOICED === null)  {this.TRIP.INVOICED = 0};
    if (this.TRIP.INVOICED === -1)  {this.TRIP.INVOICED = 1};

    this.sharedservice.loadingActive = true;
    this.dateArray.forEach(element => {
      let CustomerString = '';
      for (let RowNo = 0; RowNo < this.newCustomer.length; RowNo++) {
        CustomerString += (this.newCustomer[RowNo].name === undefined ? '' : this.newCustomer[RowNo].name) + (this.newCustomer[RowNo].cell === undefined ? '' : ',' + this.newCustomer[RowNo].cell) + '\n';
      }
      const postThis = {
        SessionID: sessionStorage.getItem('com-session-id'),
        Trip: [{
          'customer': CustomerString,
          'allDayFlag': this.TRIP.ALLDAYFLAG,
          'pickUpDate': element,
          'pickUpTime': moment(this.TRIP.PICKUPDATE).format('YYYY-MM-DD HH:mm').substr(10, 16),
          'dropOffDate': element,
          'dropOffTime': moment(this.TRIP.DROPOFFDATE).format('YYYY-MM-DD HH:mm').substr(10, 16),
          'stopsAddress': this.TRIP.STOPSADDRESS,
          'pickUpAddress': this.TRIP.PICKUPADDRESS,
          'pickUpInstructions': this.TRIP.PICKUPINSTRUCTIONS,
          'dropOffAddress': this.TRIP.DROPOFFADDRESS,
          'numberOfPeople': this.TRIP.NUMBEROFPEOPLE,
          'takeTrailor': this.TRIP.TAKETRAILOR,
          'dropOffInstructions': this.TRIP.DROPOFFINSTRUCTIONS,
          'confirmedByCustomerDate': this.TRIP.confirmedByCustomer = null,
          'confirmedByCustomerTime': this.TRIP.confirmedByCustomer = null,
          'confirmedByDriverDate': this.TRIP.confirmedByDriver = null,
          'confirmedByDriverTime': this.TRIP.confirmedByDriver = null,
          'emailSent': 1,
          'cancelled': this.TRIP.CANCELLED,
          'smsSent': this.TRIP.SMSSENT,
          'methodOfPayment_Id': this.TRIP.METHODOFPAYMENT_ID,
          'vehicle_Id': this.TRIP.VEHICLE_ID,
          'emailAddress': this.TRIP.EMAILADDRESS,
          'paid': this.TRIP.PAID,
          'notesToClient': this.TRIP.NOTESTOCLIENT,
          'invoiced': this.TRIP.INVOICED,
          'tabAccount_ID': this.TRIP.TABACCOUNT_ID,
          'DriverReadDate': this.TRIP.CONFIRMEDBYDRIVERDATE
        }]
      };
      this.httpclient.post<any>(`${this.sharedservice.URL}/dbTrip`, postThis).subscribe(Response => {
        console.log(Response);
        console.log(postThis);
        if (Response.dbTrip_response.ServiceResults[0].RESULTDESCRIPTION === 'success' && Response.dbTrip_response.ServiceResults[0].RESULTACTION === 'insert') {
          const copyID = Response.dbTrip_response.LastID;
          countsuc++;

          // drivers
            this.driverPostB = [];
            if (this.DRV.length !== 0 || this.DRV !== undefined) {
              this.DRV.forEach(element1 => {
                if ( element1.hasOwnProperty('__KEY__')) { delete element1['__KEY__']; }
                this.driverPostB.push({TRIP_ID: copyID, DRIVER_ID: element1.DRIVER_ID.toString()});
              });
              const postDriver = {
                SessionID: sessionStorage.getItem('com-session-id'),
                DeleteForTripID : copyID,
                TripDriver: this.driverPostB
              };
              this.httpclient.post<any>(`${this.sharedservice.URL}/dbTripDriver`, postDriver).subscribe(Response2 => { });
            }
          // drivers

          // TPX
            const tpxPostB = [];
            this.TXP.forEach(x => {
              if ( x.hasOwnProperty('__KEY__')) { delete x['__KEY__']; }
              tpxPostB.push({AMOUNT: x.AMOUNT, EXPENSENAME: x.EXPENSENAME, TRIP_ID: copyID})
            })

            if (this.TXP !== undefined) {
              const postThis2 = {
                SessionID: sessionStorage.getItem('com-session-id'),
                DeleteForTripID: copyID,
                TripExpense: tpxPostB
              };
              this.httpclient.post<any>(`${this.sharedservice.URL}/dbTripExpense`, postThis2).subscribe(Response3 => { });
            }
          // TXP

        } else {
          this.sharedservice.loadingActive = false;
          this.usefultoolsservice.notify('error', `Error: ${Response.dbTrip_response.ServiceErrors[0].ERRORDESCRIPTION}`);
        }
        if (countsuc === this.dateArray.length) {
          this.sharedservice.loadingActive = false;
          this.usefultoolsservice.notify('success', this.sharedservice.notificationMessages.successInsert);
          this.location.back();
        }
        this.sharedservice.loadingActive = false;
      });
      this.sharedservice.loadingActive = false;
    });
    this.sharedservice.loadingActive = false;
  }

  pushData(currentDate) {
    this.dateArray.push(moment(currentDate).format('YYYY-MM-DD HH:mm'));
  }

  myfunction(mydata1, mydata2) {
    if (moment(mydata1).format('llll').toString().indexOf(mydata2) === -1) {

    }
  }

  back() {
    sessionStorage.setItem('trips-id', '0');
    this.ID = null;
    this.DRV = [];
    this.TXP = [];
    this.location.back();
  }

  sendSMSDriver() {
    const postThis = {
      SessionID: this.sessionId,
      TripID: this.TRIP.ID,
      SMSTarget: 'DRIVER'
    };
    this.httpclient.post<any>(`${this.sharedservice.URL}/utSendSMS`, postThis).subscribe(Response => {
      if (Response.utSendSMS_response.RESULT === 'OK') {
        this.usefultoolsservice.notify('success', this.sharedservice.notificationMessages.smsSent);
      } else {
        this.usefultoolsservice.notify('error', `Error: ${Response.utSendSMS_response.queue[0].ERRORDESCRIPTION}`);
      }
    });
  }

  sendSMSClient() {
    const postThis = {
      SessionID: this.sessionId,
      TripID: this.TRIP.ID,
      SMSTarget: 'CLIENT'
    };
    this.httpclient.post<any>(`${this.sharedservice.URL}/utSendSMS`, postThis).subscribe(Response => {
      if (Response.utSendSMS_response.RESULT === 'OK') {
        this.usefultoolsservice.notify('success', this.sharedservice.notificationMessages.smsSent);
      } else {
        this.usefultoolsservice.notify('error', `Error: ${Response.utSendSMS_response.queue[0].ERRORDESCRIPTION}`);
      }
    });
  }

  toggleDelete(data) {
    if (data === true) {
      this.popupVisibleDelete = true;
    } else {
      this.popupVisibleDelete = false;
    }
  }
}
